<section class="auction-skeleton">
  <ngx-skeleton-loader
    [count]="1"
    [theme]="{
      'border-radius': '0.625rem',
      width: '100%',
      height: '2rem',
      margin: '0 0 1rem',
      backgroundColor: '#e8edf5',
    }"></ngx-skeleton-loader>

  <div class="auction-skeleton__layout">
    <div class="auction-skeleton__media">
      <ngx-skeleton-loader
        [count]="1"
        [theme]="{
          'border-radius': '0.75rem',
          width: '100%',
          height: '22rem',
          backgroundColor: '#e8edf5',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [count]="4"
        [theme]="{
          'border-radius': '0.5rem',
          width: '100%',
          height: '3.5rem',
          margin: '0.5rem 0 0',
          backgroundColor: '#e8edf5',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [count]="1"
        [theme]="{
          'border-radius': '0.75rem',
          width: '100%',
          height: '9.5rem',
          margin: '1rem 0 0',
          backgroundColor: '#e8edf5',
        }"></ngx-skeleton-loader>
    </div>

    <div class="auction-skeleton__sidebar">
      <ngx-skeleton-loader
        [count]="1"
        [theme]="{
          'border-radius': '0.75rem',
          width: '100%',
          height: '28rem',
          backgroundColor: '#e8edf5',
        }"></ngx-skeleton-loader>
    </div>
  </div>
</section>
